import { useModal } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'

import { getPolicyVersion, inForce, isDiscount } from '../../../../domain'
import { getFeatureToggles, useConfig } from '../../../../state/configuration'
import {
  OfferTermsModalContent,
  PromotionBannerActivated,
} from '../../../organisms/promotion'
import { usePolicy } from '../policyContext'

export const OldPolicyPromotionBanner: FunctionComponent = () => {
  const modal = useModal()
  const { policy } = usePolicy()
  const { hidePromotionBanner } = useConfig(getFeatureToggles)

  const { quote } = getPolicyVersion(policy)

  const discount = quote.priceBreakdown.find(isDiscount)

  const onOfferTermsClick = useCallback(() => {
    if (discount) {
      modal.show({
        content: <OfferTermsModalContent promoCode={discount.productCode} />,
      })
    }
  }, [modal, discount])

  return !quote.promoCode && !hidePromotionBanner && inForce(discount) ? (
    <PromotionBannerActivated onOfferTermsClick={onOfferTermsClick} />
  ) : null
}
